import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IGetListDetailsResponse, IFavouritesResponse, IGetTopicsResponse, IListsDataResponse } from '@models/lists.model';
import { Injectable } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListsService {

  private URL: string = environment.rootUrl;

  constructor(
    private http: HttpClient
  ) { }


  public async getFavouritesLists(): Promise<IFavouritesResponse> {
    return firstValueFrom(this.http.get<IFavouritesResponse>(`${this.URL}/lists/favorites`));
  }


  public async addProductToFavouritesList(data: any): Promise<any> {
    return this.http.put(`${this.URL}/lists/favorites/items`, data).toPromise();
  }

  public async addProductToMyList(data: any, list_id: number): Promise<any> {
    return this.http.put(`${this.URL}/lists/${list_id}/items`, data).toPromise();
  }

  public async getMyLists(): Promise<IListsDataResponse> {
    return firstValueFrom(this.http.get<IListsDataResponse>(`${this.URL}/lists`));
  }

  public async getListDetails(id: string, store_id?: string): Promise<IGetListDetailsResponse> {
    let params = new HttpParams();
    if (store_id) {
      params = params.set('branch', store_id);
    }
    return firstValueFrom(this.http.get<IGetListDetailsResponse>(`${this.URL}/lists/${id}`, { params }));
  }

  public async deleteProductFromList(list_id: number, item_id: number): Promise<any> {
    return this.http.delete(`${this.URL}/lists/${list_id}/items/${item_id}`).toPromise();
  }

  public async getImages(page: number, limit: number): Promise<any> {
    return this.http.get(`${this.URL}/lists/pictures?page=${page}&limit=${limit}`).toPromise();
  }

  public async createList(data: any): Promise<any> {
    return this.http.post(`${this.URL}/lists`, data).toPromise();
  }

  public async editList(data: any, list_id: number): Promise<any> {
    return this.http.patch(`${this.URL}/lists/${list_id}`, data).toPromise();
  }

  public async deleteList(list_id: string): Promise<any> {
    return this.http.delete(`${this.URL}/lists/${list_id}`).toPromise();
  }

  public async getAlsuperLists(): Promise<any> {
    return this.http.get(`${this.URL}/lists/alsuper`).toPromise();
  }

  public getTopics(): Observable<IGetTopicsResponse> {
    return this.http.get<IGetTopicsResponse>(`${this.URL}/lists/topics`);
  }
}
